module.exports = __webpack_public_path__ + "static/img/company-4.5df2f0b3.png";